import React from 'react';
import * as S from './BusinessNeeds.styles';


const BusinessNeeds = () => {
    return(
        <S.BusinessNeedsMainWrap>
            <S.BusinessNeedsInnerWrap>
                <S.BusinessNeedHeadWrap>
                    <S.BusinessNeedsHeadText>All Your Business Needs On One Platform! </S.BusinessNeedsHeadText>
                </S.BusinessNeedHeadWrap>
                <S.BuinessInfoCardWrap>
                    <S.BusinessInfoCard>
                        <S.BusinessInfoCardImgWrap>
                            <S.BusinessInfoTypeTag>
                                <S.BusinessInfoTypeText>Flight</S.BusinessInfoTypeText>
                            </S.BusinessInfoTypeTag>
                            <S.BusinessInfoImg src="https://mypartnerimgak.mmtcdn.com/media/flight-banner.png" alt="flights" />
                        </S.BusinessInfoCardImgWrap>
                        <S.BusinessInfoTextWrap>
                            <S.BusinessInfoText><span></span>Best ever rates</S.BusinessInfoText>
                            <S.BusinessInfoText><span></span>300+ Airline carriers</S.BusinessInfoText>
                            <S.BusinessInfoText><span></span>Easy & quick post booking modifications</S.BusinessInfoText>
                        </S.BusinessInfoTextWrap>
                    </S.BusinessInfoCard>
                    <S.BusinessInfoCard>
                        <S.BusinessInfoCardImgWrap>
                            <S.BusinessInfoTypeTag>
                                <S.BusinessInfoTypeText>Hotels</S.BusinessInfoTypeText>
                            </S.BusinessInfoTypeTag>
                            <S.BusinessInfoImg src="https://mypartnerimgak.mmtcdn.com/media/hotel-banner.png" alt="hotels" />
                        </S.BusinessInfoCardImgWrap>
                        <S.BusinessInfoTextWrap>
                            <S.BusinessInfoText><span></span>Exclusive rates</S.BusinessInfoText>
                            <S.BusinessInfoText><span></span>8 lac+ Hotels properties</S.BusinessInfoText>
                            <S.BusinessInfoText><span></span>Best-in-class free-cancellation policies</S.BusinessInfoText>
                        </S.BusinessInfoTextWrap>
                    </S.BusinessInfoCard>
                </S.BuinessInfoCardWrap>
            </S.BusinessNeedsInnerWrap>
        </S.BusinessNeedsMainWrap>
    )
}

export default BusinessNeeds;